export default __webpack_public_path__ + "static/5_18-b8e4528bf404bba60d8b03adaf60ac07.png";